import React from 'react';
import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  PaperProps,
  Popover,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import {
  ICourseTutorForAdmin,
  ICourseTutorForUser,
} from '../../store/V2/CourseTutorsSlice';

interface CourseTutorDetailCardWithPopOverProps {
  courseTutor: ICourseTutorForAdmin | ICourseTutorForUser;
  showFullName?: boolean;
}

const containerStyles: SxProps = {
  borderRadius: '10px',
  width: 'fit-content',
};

const cardActionAreaStyles: SxProps = {
  transition: 'all ease-out 0.3s',
  '&:hover': {
    backgroundColor: '#E2E8F0',
  },
};

const popOverPaperProps: PaperProps = {
  sx: {
    borderRadius: '20px',
    boxShadow: '0px 14px 40px 0px #6E9DB22E',
    border: '1px solid #E2E8F0',
    minWidth: '250px',
    maxWidth: '250px',
  },
};

const chipAvatarStyles: SxProps = { width: '34px', height: '34px', mr: '3px' };

const CustomLi = ({ text }: { text: string }) => {
  return (
    <Typography
      component="li"
      mb="10px"
      sx={{ '&::marker': { color: '#1C9FF7' } }}
    >
      {text}
    </Typography>
  );
};

const CourseTutorDetailCardWithPopOver: React.FC<CourseTutorDetailCardWithPopOverProps> = ({
  courseTutor,
  showFullName = false,
}) => {
  // State
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const { tutor } = courseTutor;

  let name = '';
  let avatarUrl = '';

  const isPopperOpen = Boolean(anchorEl);
  const popperId = isPopperOpen ? 'simple-popover' : undefined;

  if (tutor) {
    name = tutor.firstname;
    avatarUrl = tutor.avatar || '';

    if (tutor.lastname) {
      if (showFullName) {
        name += ` ${tutor.lastname}`;
      } else {
        name += ` ${tutor.lastname.substring(0, 1)}.`;
      }
    }
  }

  const openPopper = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closePopper = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Card elevation={0} sx={containerStyles}>
        <CardActionArea
          aria-describedby={popperId}
          onClick={openPopper}
          sx={cardActionAreaStyles}
        >
          <CardContent style={{ padding: '5px' }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              gap={2}
            >
              <Avatar sx={chipAvatarStyles} src={avatarUrl} />
              <Typography
                variant="subtitle2"
                fontSize="16px"
                className="ellipsis-text"
                fontWeight={600}
                mr="3px"
                maxWidth="150px"
              >
                {name}
              </Typography>
              <InfoIcon style={{ width: '15px', height: '15px' }} />
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>
      <Popover
        id={popperId}
        open={isPopperOpen}
        anchorEl={anchorEl}
        onClose={closePopper}
        PaperProps={popOverPaperProps}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div style={{ padding: '15px' }}>
          <Stack>
            <Stack alignItems="center" mb="15px">
              <Avatar sx={{ width: '80px', height: '80px' }} src={avatarUrl} />
            </Stack>
            <div>
              <Typography
                className="ellipsis-text"
                fontSize="16px"
                fontWeight={500}
                textAlign="center"
                color="#1C9FF7"
              >
                {name}
              </Typography>
            </div>
            {/* <div>
              <Typography
                className="ellipsis-text"
                fontSize="14px"
                fontWeight={500}
                textAlign="center"
              >
                {user.email}
              </Typography>
            </div> */}
          </Stack>
          <div>
            <Typography component="ul" sx={{ padding: '15px' }}>
              {courseTutor.title ? <CustomLi text={courseTutor.title} /> : null}
              {courseTutor.description ? (
                <Typography
                  component="li"
                  mb="10px"
                  sx={{ '&::marker': { color: '#1C9FF7' } }}
                >
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: courseTutor.description,
                    }}
                  />
                </Typography>
              ) : null}
            </Typography>
          </div>
        </div>
      </Popover>
    </>
  );
};

export default CourseTutorDetailCardWithPopOver;
